import * as React from 'react'

import { Box, CheckBox, Text } from '@factorialco/deprecated-design-system'
import { difference } from 'lodash'

import i18n from 'modules/core/lib/i18n'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

interface Props {
  disabled: boolean
  onSelectMultiple?: ((...args: any[]) => any) | null
  selectedIds: string[]
  legalEntities: LegalEntity[]
}

export default function Controls({
  onSelectMultiple,
  legalEntities,
  selectedIds,
  disabled,
}: Props) {
  if (!onSelectMultiple) return null

  const legalGenderIds = legalEntities.map((legalEntity) => legalEntity.attributes.id)

  const onSelectAll = () => {
    if (disabled) return

    if (!legalGenderIds.length) return onSelectMultiple(legalGenderIds)

    const selection = [...new Set([...selectedIds, ...legalGenderIds])]
    onSelectMultiple(selection)
  }

  const onSelectNone = () => {
    if (disabled) return

    onSelectMultiple(difference(selectedIds, legalGenderIds))
  }

  const selected = !difference(legalGenderIds, selectedIds).length
  const toggle = () => (selected ? onSelectNone() : onSelectAll())

  return (
    <Box
      alignItems="center"
      background="grey200"
      flexDirection="row"
      gap="s16"
      paddingX="s16"
      paddingY="s12"
      width="full"
    >
      <CheckBox checked={selected} onClick={toggle} />
      <Text.Normal size="200" weight="medium">
        {i18n.t('common.name')}
      </Text.Normal>
    </Box>
  )
}
